//@state
export interface profileState {
  userInfo: any
}

export const initialState: profileState = {
  userInfo: {}
}

